// import { useParams } from "react-router-dom";
import { UserAddIcon } from "@heroicons/react/outline";
import { useParams } from "react-router-dom";
import Board from "./Dashboard/Board";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, database } from "../../database/firebase";
import { useEffect, useState } from "react";
import useMembers from "../../hooks/DatabseCollection/useMembers";
import useRoomId from "../../hooks/DatabseCollection/useRoomId";
import {
  addDoc,
  collection,
  onSnapshot,
  serverTimestamp,
} from "firebase/firestore";

const DashboardTab = () => {
  const [user] = useAuthState(auth);
  const { roomId } = useParams();
  const [memberUser, setMemberUser] = useState(false);
  const [memberData] = useMembers(roomId);
  const { roomDetail } = useRoomId(roomId);
  const [requestedMember, setRequestedMember] = useState([]);
  const [hasbeenRequestedMember, setHasbeenRequestedMember] = useState(false);

  useEffect(() => {
    setMemberUser(memberData.find((mem) => mem.data.memberId === user.uid));
  }, [memberData, user.uid]);

  useEffect(() => {
    setHasbeenRequestedMember(
      requestedMember.find((mem) => mem.data.memberId === user.uid)
    );
  }, [requestedMember, user.uid]);

  useEffect(() => {
    onSnapshot(
      collection(database, "userRooms", roomId, "request"),
      (snapshot) => {
        setRequestedMember(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            data: doc.data(),
          }))
        );
      }
    );
  }, [roomId]);

  const joinRoom = async () => {
    try {
      await addDoc(collection(database, "userRooms", roomId, "members"), {
        memberName: user?.displayName,
        memberId: user?.uid,
        memberEmail: user?.email,
        memberImage: user?.photoURL,
        isAdmin: false,
        timestamp: serverTimestamp(),
      });
    } catch (error) {
      alert(error.message);
    }
  };

  const sendRequest = async () => {
    try {
      await addDoc(collection(database, "userRooms", roomId, "request"), {
        memberName: user?.displayName,
        memberId: user?.uid,
        memberEmail: user?.email,
        memberImage: user?.photoURL,
        isAdmin: false,
        timestamp: serverTimestamp(),
      });
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="sm:grid sm:grid-cols-2 sm:gap-8">
      {!memberUser && (
        <div className="">
          <div className="py-10 border border-gray-300 shadow bg-gray-50 rounded-2xl grid place-items-center">
            <UserAddIcon className="h-14 text-gray-700 font-thin" />
            <div className="flex flex-col justify-center items-center space-y-5 mt-5">
              <h1 className="text-lg text-gray-600">
                This is a{" "}
                {roomDetail.privacyMode === "Private"
                  ? "private room please send request to join"
                  : "public room you can join"}
              </h1>
              {roomDetail.privacyMode === "Private" ? (
                <>
                  {hasbeenRequestedMember ? (
                    <h1 className="text-red-500 font-semibold">
                      Request has been sent
                    </h1>
                  ) : (
                    <button
                      onClick={sendRequest}
                      className="px-4 py-2 border border-green-500 focus:outline-none rounded-lg text-green-500 shadow"
                    >
                      Send Request
                    </button>
                  )}
                </>
              ) : (
                <button
                  onClick={joinRoom}
                  className="px-4 py-2 border border-green-500 focus:outline-none rounded-lg text-green-500 shadow"
                >
                  Join Public Room
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {memberUser && (
        <div className="h-[400px] border border-gray-300 shadow rounded-lg">
          <Board />
        </div>
      )}
      {memberUser ? (
        <div className="grid place-items-center">
          <img src="/images/ChatImage.svg" alt="immmmm" className="h-40" />
        </div>
      ) : (
        <div className="grid place-items-center">
          <img src="/images/GroupImage.svg" alt="immmmm" className="h-72" />
        </div>
      )}
    </div>
  );
};

export default DashboardTab;
